import { lazy } from 'react';

import UseAppPage from 'Pages/Common/UseApp/UseAppPage';
import OnboardingOfferPage from 'Pages/Guest/Onboarding/Offer/OnboardingOfferPage';
import { Navigate, RouteObject } from 'react-router-dom';
import PrivateWrapper from './PrivateWrapper';

const OnboardingReboarding = lazy(
    () => import('Pages/Protected/OnboardingReboarding'),
);
const PaymentSuccessPage = lazy(() => import('Pages/Protected/PaymentSuccess'));

const protectedRoutes: RouteObject = {
    path: '/',
    element: <PrivateWrapper />,
    children: [
        {
            path: '/',
            element: <Navigate to="/useapp" replace />,
        },
        {
            path: '/welcome-new',
            element: <OnboardingReboarding />,
        },
        {
            path: '/onboarding/offer',
            element: <OnboardingOfferPage />,
        },
        {
            path: '/payment-success',
            element: <PaymentSuccessPage />,
        },
        {
            path: '/useapp',
            element: <UseAppPage />,
        },
    ],
};

export default protectedRoutes;
